<template>
  <div class="remote-control-container">
    <Search :formModel="formModel" :formButton="formButton" :deviceModelBusiType="2" />
    <MTable
      :loading="loading"
      :tableData="data"
      :tableColumn="tableColumn"
      :pagiOption="pagiOption"
      :oprateMenu="oprateMenu"
      v-on:search="search"
    />

    <!-- BM3001 -->
    <el-dialog title="发送" :visible.sync="BM3001Visable" width="500px">
      <BM3001Dialog
        v-if="BM3001Visable"
        :sn="deviceSN"
        @closeBM3001Dialog="BM3001Visable = false"
        @sendSuccess="sendSuccessFunc"
      ></BM3001Dialog>
    </el-dialog>

    <el-dialog title="发送" :visible.sync="FCBRVisable" width="500px">
      <FCBRDialog
        v-if="FCBRVisable"
        :sn="deviceSN"
        @closeFCBRDialog="FCBRVisable = false"
        @sendSuccess="sendSuccessFunc"
      ></FCBRDialog>
    </el-dialog>
  </div>
</template>

<script>
import Search from '@/components/mTable/search.vue';
import MTable from '@/components/mTable/m-table.vue';
import BM3001Dialog from './components/BM3001-dialog.vue';
import FCBRDialog from './components/FCBR-dialog.vue';
import { getDeviceList } from '@/api/remoteControl';
import { cr3000, cr2500 } from '@/components/virtualPhone/index';

export default {
  sockets: {
    '/socket/remote/control'() {
      // const { sn, status, message } = res;
      this.search();
      // this.$message({
      //   type: isFinish(status) ? 'success' : 'warning',
      //   message: `${sn}，${message}`
      // });
    }
  },
  components: {
    Search,
    MTable,
    BM3001Dialog,
    FCBRDialog
  },
  data() {
    return {
      deviceSN: '',
      BM3001Visable: false,
      FCBRVisable: false,
      dialogType: '',
      detectLoadingMap: {},
      loading: false,
      formModel: {
        deviceModel: [],
        sn: []
      },
      formButton: [
        {
          text: '查询',
          event: () => {
            this.pagiOption.offset = 1;
            this.search();
          }
        }
      ],
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        { label: '设备名称', prop: 'deviceName' },
        { label: '设备类型', prop: 'deviceTypeCode' }
      ],
      oprateMenu: {
        label: '操作',
        width: 360,
        list: [
          {
            text: '远程控制',
            disabled: ({ row }) => row.status === 'detecting',
            access: () => true,
            event: (_, data) => {
              if (data.deviceTypeCode === 'CR3000') {
                cr3000.create(data);
              } else if (data.deviceTypeCode === 'CR2500') {
                cr2500.create(data);
              } else if (data.deviceTypeCode === 'BM3001') {
                this.BM3001Visable = true;
                this.deviceSN = data.sn;
              } else if (data.deviceTypeCode.startsWith('FCBR')) {
                this.FCBRVisable = true;
                this.deviceSN = data.sn;
              } else {
                this.$message.warning('该设备暂不支持');
              }
            }
          }
        ]
      },
      data: null
    };
  },
  methods: {
    sendSuccessFunc() {
      this.deviceSN = '';
      this.BM3001Visable = false;
      this.FCBRVisable = false;
      this.dialogType = '';
    },
    subscribeMessage() {
      // TODO 远程控制订阅
      // this.$socket.emit('/socket/remote/control');
    },
    unsubMessage() {
      // TODO 远程控制取消订阅
    },
    search() {
      const { offset, limit } = this.pagiOption;
      const { sn, deviceModel } = this.formModel;
      this.getData({
        sn: sn.length ? sn : undefined,
        deviceTypeCode: deviceModel.length ? deviceModel : undefined,
        offset,
        limit
      });
    },
    getData(params) {
      getDeviceList(params).then(res => {
        const { total, list } = res.data;
        this.data = list;
        this.pagiOption.total = total;
      });
    }
  },
  created() {
    this.subscribeMessage();
    this.search();
  },
  beforeDestroy() {
    this.unsubMessage();
    cr3000.remove();
  }
};
</script>

<style lang="scss">
.remote-control-container {
  width: 100%;
}
</style>
